export default (params) => ({
  trigger: {
    name: 'order_block.select_order_type',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'one-time',
          'lease',
          'subscription',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'order_type',
      },
    },
  },
});
